import React from "react";
import "../../App.css";
import {Box, Grid, Typography} from "@mui/material";
import FooterLogo from "./FooterLogo";
import FooterMenu from "./FooterMenu";

const Footer = () => {
    return (
        <Box style={{
            backgroundColor: "#29362C",
            textAlign: 'center',
            alignContent: "center",
            paddingBottom: '20px',
        }}>

            <Box
                sx={{
                    maxWidth: "60%",
                    mx: "auto", // Center the content horizontally
                    // width: "100%", // Ensure it adjusts on smaller screens
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <Grid container
                      spacing={2}
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                          flexDirection: {xs: "column", sm: "row"},
                      }}>
                    <Grid
                        item xs={12} sm={6}>
                        <FooterLogo/>
                        <FooterMenu/>

                    </Grid>

                    {/*<Grid*/}
                    {/*    sx={{*/}
                    {/*        display: {xs: 'none', md: 'block'},*/}
                    {/*    }}*/}
                    {/*    item xs={12} sm={4}>*/}
                    {/*    <FooterMenu/>*/}
                    {/*</Grid>*/}

                    {/* Contact Section */}
                    {/*<Grid item xs={12} sm={4}>*/}
                    {/*    <FooterContacts/>*/}
                    {/*</Grid>*/}

                    {/*<Grid item xs={12} sm={12}>*/}
                    {/*    <LanguageSwitcher/>*/}
                    {/*</Grid>*/}
                </Grid>
                <Box>
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'white',
                            textDecoration: 'none',
                            paddingTop: {
                                xs: '15px',
                                md: '5px',
                            }
                        }}
                    >
                        Since 2024
                    </Typography>
                </Box>
            </Box>

        </Box>
    );
};

export default Footer;
